import 'bootstrap';
import 'slick-carousel';
import 'jquery-mask-plugin/dist/jquery.mask.min';

window._ = require('lodash');

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
} catch (e) {}

jQuery(function(){

    mainHeight();
    
    $(window).scroll(function () {
        mainHeight();
    });
    $(window).on('resize', function () {
        mainHeight();
    });

    function mainHeight() {
        var alturaHeader = $('header').outerHeight();
        $('main').css('margin-top', alturaHeader);
    }

    jQuery('.mask-phone').mask('(00) 0 0000-0000');

    $('.slick-valores').slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 6000,
        arrows: true,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
    });

    $('.slick-main-banner').each(function () {
        var $slider = $(this);
        var $wrapper = $slider.closest('.main-banner-wrapper');
        var $controls = $wrapper.find('.main-banner-controls');
        var $prevArrow = $controls.find('.main-banner-control--prev');
        var $nextArrow = $controls.find('.main-banner-control--next');

        $slider.slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 6000,
            arrows: true,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            appendArrows: $controls.length ? $controls : $slider,
            prevArrow: $prevArrow.length ? $prevArrow : '<button type="button" class="slick-arrow slick-prev" aria-label="Anterior banner"><span aria-hidden="true">&lsaquo;</span></button>',
            nextArrow: $nextArrow.length ? $nextArrow : '<button type="button" class="slick-arrow slick-next" aria-label="Próximo banner"><span aria-hidden="true">&rsaquo;</span></button>',
        });
    });

    $('.js-atuacao-carousel').each(function () {
        var $slider = $(this);
        var $wrapper = $slider.closest('.atuacao-carousel-wrapper');
        var $prev = $wrapper.find('.atuacao-control--prev');
        var $next = $wrapper.find('.atuacao-control--next');

        $slider.slick({
            infinite: true,
            autoplay: false,
            arrows: true,
            dots: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: $prev.length ? $prev : '<button type="button" class="slick-arrow slick-prev" aria-label="Área anterior"><span aria-hidden="true">&lsaquo;</span></button>',
            nextArrow: $next.length ? $next : '<button type="button" class="slick-arrow slick-next" aria-label="Próxima área"><span aria-hidden="true">&rsaquo;</span></button>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    });

    $(".btn-aside-mob").click(function(){
        $(".aside-mobile").toggleClass("menu-open");
        $(".btn-aside-mob i").toggleClass("flipH");
        return false;
    });
});
